// I MESSAGGI DELL'ACCESSO E DELLA REGISTRAZIONE, NELLA LINGUA DI CHI LEGGE
// (2026-09-19).
//
// Prima AuthPage faceva setError(err.message) e mostrava il testo grezzo della
// rotta: «An account with this email already exists» compariva identico in
// italiano, spagnolo, francese e tedesco. Sono 45 volte in quindici giorni
// solo per quel caso, cioe' 45 persone che hanno letto una frase in una
// lingua che magari non conoscono nel momento in cui stavano creando un
// account.
//
// SI MAPPA SULLA STRINGA, NON SU UN CODICE, perche' un codice non c'e': le
// rotte di /auth/register e /auth/login rispondono con `error` in inglese e
// nient'altro (routes/auth.js). utils/api.js quella stringa la mette in
// `err.codice` insieme allo `status`, quindi qui si guarda quella.
//
// LA REGOLA CHE CONTA: se arriva qualcosa che non e' in questa tabella, si
// mostra la frase generica tradotta, MAI la stringa inglese. Un messaggio
// generico nella propria lingua e' piu' utile di uno preciso in una lingua
// che non si legge, e soprattutto non tradisce che dentro c'e' un server che
// parla inglese.
const TABELLA = {
  // ── registrazione (routes/auth.js, rotta /register)
  'An account with this email already exists': 'err_srv_email_esistente',
  'Email required': 'err_srv_email_mancante',
  'Invalid email': 'err_srv_email_non_valida',
  'Password min 8 characters': 'err_password_too_short',
  'password, salt required': 'err_srv_dati_mancanti',
  "This domain doesn't appear to accept email — please check it for typos.": 'err_email_undeliverable',
  // ── accesso (routes/auth.js, rotta /login)
  'username and password required': 'err_srv_dati_mancanti',
  'Invalid credentials': 'err_srv_credenziali',
  'Account suspended': 'err_srv_sospeso',
  // ── secondo fattore (rotta /login/2fa)
  'pendingToken and code required': 'err_srv_dati_mancanti',
  'Pending token expired — please log in again': 'err_srv_sessione_scaduta',
  'Invalid pending token': 'err_srv_sessione_scaduta',
  'User not found': 'err_srv_credenziali',
  // ── qualunque rotta
  'Server error': 'err_srv_server',
};

export function erroreAutenticazione(err, t) {
  // La rete caduta non e' un errore del server e ha un rimedio diverso:
  // riprovare, non correggere quello che si e' scritto.
  if (err && err.isNetworkError) return t('err_srv_rete');

  const chiave = TABELLA[(err && err.codice) || ''];
  if (chiave) return t(chiave);

  // Niente in tabella: si prova almeno a distinguere per stato, cosi' un
  // messaggio nuovo del server non diventa comunque un muro.
  const stato = err && err.status;
  if (stato === 401 || stato === 403) return t('err_srv_credenziali');
  if (stato >= 500) return t('err_srv_server');
  return t('err_srv_generico');
}
